import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { consumer } from '../../../helpers/consumer.js';
import { queryKeyFor } from './constants.js';

// Refetches every widget query of the datasource once a background refresh has landed.
// onRefreshed lets non react-query consumers (dialog grids) reload as well.
export default function useDatasourceV2Channel(datasourceId, onRefreshed = null) {
  const queryClient = useQueryClient();
  const onRefreshedRef = useRef(onRefreshed);
  onRefreshedRef.current = onRefreshed;

  useEffect(() => {
    if (!datasourceId) return undefined;

    const subscription = consumer.subscriptions.create(
      { channel: 'DatasourceV2Channel', datasource_id: datasourceId },
      {
        received: (data) => {
          if (data.event === 'refreshed') {
            queryClient.invalidateQueries({ queryKey: queryKeyFor(datasourceId) });
            queryClient.invalidateQueries({ predicate: (q) => q.queryKey[0] === 'datasource_v2_schema' && q.queryKey[2] === datasourceId });
            onRefreshedRef.current?.();
          }
        },
      },
    );

    return () => subscription.unsubscribe();
  }, [datasourceId, queryClient]);
}
